<app-resp-popup-title>
  <span i18n="@@AnlageAPI_MonitoringBlackboxSelect_Title"
    >Select a facility from the monitoring system</span
    >
  </app-resp-popup-title>
  <app-resp-popup-content>
    <div style="width: 1400px; max-width: 92vw">
      <form [formGroup]="formFilter">
        <div class="row">
          <div class="col-11"></div>
          <div class="col-1">
            <ctrl-btn icon="refresh" (click)="dataSource.refresh()"></ctrl-btn>
          </div>
        </div>
      </form>
      <div style="height: 900px; max-height: 65vh">
        <app-list-view
          [elevated]="false"
          [columns]="columns"
          [dataSource]="dataSource"
          [getRowStyle]="getRowStyle"
          [compact]="true"
          [canRowBeClicked]="canBlackboxSelect"
          (rowClicked)="onBlackboxSelect($event)"
          id="MonitoringBlackboxSelect"
        ></app-list-view>
      </div>
    </div>
  </app-resp-popup-content>

  <ng-template #columnStatus let-element="element">
    @if (element.isLinked) {
      <mat-icon
        [title]="'Verbunden mit Anlage ' + element.linkedToAmFacilityNo"
        >link</mat-icon
        >
      }
    </ng-template>
